import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=49fee5a1&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=49fee5a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fee5a1",
  null
  
)

export default component.exports